import React from 'react';
import { Card } from './ui/card';
import { Trophy, Film, Tv, ArrowRight } from 'lucide-react';
import { categories } from '../mock';

const iconMap = {
  Trophy: Trophy,
  Film: Film,
  Tv: Tv
};

const Categories = () => {
  const handleCardClick = () => {
    // Scroll to hero CTA button
    document.getElementById('inicio')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  return (
    <section id="categorias" className="py-16 md:py-24 bg-gradient-to-b from-black via-zinc-950 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4">
            Explore Nosso <span className="text-red-600">Conteúdo</span>
          </h2>
          <p className="text-gray-400 text-lg md:text-xl max-w-2xl mx-auto">
            Acesse milhares de horas de entretenimento premium
          </p>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {categories.map((category) => {
            const IconComponent = iconMap[category.icon];
            return (
              <Card
                key={category.id}
                onClick={handleCardClick}
                className="group relative overflow-hidden bg-zinc-900 border-zinc-800 hover:border-red-600 transition-all duration-300 cursor-pointer hover:scale-105"
              >
                {/* Background Image */}
                <div className="relative h-64 md:h-80 overflow-hidden">
                  <img
                    src={category.image}
                    alt={category.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>
                </div>

                {/* Content Overlay */}
                <div className="absolute inset-0 flex flex-col justify-end p-6">
                  <div className="bg-red-600 w-12 h-12 rounded-lg flex items-center justify-center mb-4 group-hover:bg-red-500 transition-colors">
                    <IconComponent className="w-6 h-6 text-white" />
                  </div>
                  <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">
                    {category.name}
                  </h3>
                  <p className="text-gray-300 mb-4">{category.description}</p>
                  <div className="flex items-center text-red-500 font-semibold group-hover:text-red-400 transition-colors">
                    Explorar
                    <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-2 transition-transform" />
                  </div>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Categories;
